module.exports = __webpack_public_path__ + "static/media/card-icon-3.83403a17.svg";